import { call, put, takeLatest } from 'redux-saga/effects';
import {
  APP_AUTH_START,
  SET_LOCATION,
  CONFIG,
  SUPPORT_SEND,
  SHOW_NOTIFY,
  NOTIFY_LEVEL,
  RequestStatus,
} from 'constants';
import AppUtils from '@control-front-end/utils/utils';
import api from '@control-front-end/common/sagas/api';
const apiSettingsKeys = ['transactions'];

/**
 * Получение конфига приложения
 */
function* getConfig() {
  const { result, data } = yield call(api, {
    method: 'get',
    url: '/config',
  });
  if (result === 'success') {
    const { result: settingsResult, data: settingsData } = yield call(api, {
      method: 'get',
      url: '/config/settings',
      queryParams: { keys: apiSettingsKeys },
    });
    const configPayload =
      settingsResult === 'success'
        ? { ...data.data, ...settingsData.data }
        : { ...data.data };
    yield put({
      type: CONFIG.SUCCESS,
      payload: configPayload,
    });
    yield put({ type: APP_AUTH_START.REQUEST });
    yield put({ type: SET_LOCATION, payload: document.location.pathname });
  } else if (result === 'error') {
    yield put({ type: CONFIG.ERROR });
  }
}

/**
 * Отправить форму на саппорт
 */
function* supportSend({ payload, formActions }) {
  const { result } = yield call(api, {
    method: 'post',
    url: '/support',
    body: payload,
  });
  formActions.setSubmitting(false);
  if (result !== RequestStatus.SUCCESS) return;
  if (formActions) formActions.onClose();
  yield put({
    type: SHOW_NOTIFY.REQUEST,
    payload: {
      id: AppUtils.createRid(),
      type: NOTIFY_LEVEL.SUCCESS,
      label:
        'Thank you for contacting us. We will do our best to respond as soon as possible',
    },
  });
}

function* config() {
  yield takeLatest(CONFIG.REQUEST, getConfig);
  yield takeLatest(SUPPORT_SEND.REQUEST, supportSend);
}

export default config;
